module.exports = __webpack_public_path__ + "img/rebecca-mills-hello-fish-friends.3aaadb5.jpg";